<div class="flex flex-row space-x-2 items-start">
  <div (click)="click()">
    <div #customIconRef><ng-content #gg select="[itemCardIcon]"></ng-content></div>

    <ng-container *ngIf="!customIconRef.childElementCount">
      <img class="icon" *ngIf="iconLink" [src]="iconLink" alt="Element Icon" [ngStyle]="{ 'object-fit': imageFit }" />
      <div *ngIf="!iconLink" class="icon flex flex-col justify-center items-center">
        <mat-icon class="s-32">{{ disabled ? 'block' : 'add_circle_outline' }}</mat-icon>
      </div>
    </ng-container>
  </div>

  <div class="flex-1" *ngIf="title || description">
    <div class="mat-caption">{{ title }}</div>
    <div class="mat-caption secondary-text">{{ description }}</div>

    <ng-content #actions></ng-content>
  </div>

  <button mat-icon-button *ngIf="cleanable" (click)="clean()">
    <mat-icon>delete</mat-icon>
  </button>
</div>
